module.exports = __webpack_public_path__ + "static/img/Frame525.063d1fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Frame525.svg
// module id = NQD8
// module chunks = 74